/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { a11y, colors, fonts } from '@blend/consumer-components';

const styles = StyleSheet.create({
  legend: {
    border: 'none',
    fontWeight: fonts.weight.medium,
    fontSize: 13,
    color: colors.clayPlus4,
  },
});

export namespace Wrapper {
  export interface Props extends React.HTMLAttributes<HTMLFieldSetElement> {
    legend: string;
  }
}

export const Wrapper: React.SFC<Wrapper.Props> = ({ children, legend, ...htmlProps }) => {
  return (
    <fieldset {...htmlProps}>
      <legend className={css([styles.legend, a11y.srOnly])}>{legend}</legend>
      {children}
    </fieldset>
  );
};
